import { html } from "../../../../../../../_ovlclient/src"
import {
  FeatureInfo,
  PermissionHas,
} from "../../../../../../../_ovlclient/src/global/globalapi"
import { T } from "../../../../../../../_ovlclient/src/global/globals"
import { DialogOpen } from "../../../../../../../_ovlclient/src/library/dialog/dialogapi"

import { SYSBaseElement } from "../../../../../../../_ovlclient/src/library/sysbaseelement"
import { TableRefresh } from "../../../../../../../_ovlclient/src/library/table/tableapi"

export class CompSettings extends SYSBaseElement {
  handleUserAdministrationUser = async (e: Event) => {
    await TableRefresh("SYSUserAdministration_Role")
    await TableRefresh("SYSUserAdministration_User")
    DialogOpen("SYSUserAdministration_User")
  }
  handleUserAdministrationCompany = async (e: Event) => {
    await TableRefresh("SYSUserAdministration_Company")
    DialogOpen("SYSUserAdministration_Company")
  }

  handleUserAdministrationRole = async (e: Event) => {
    await TableRefresh("SYSUserAdministration_Role")
    DialogOpen("SYSUserAdministration_Role")
  }

  async getUI() {
    let offeringSettings
    if (FeatureInfo("QUTOfferingTool") || FeatureInfo("QUTOfferingToolAdmin")) {
      offeringSettings = html`<comp-offeringsettings></comp-offeringsettings>`
    }

    return html`
      <div class="ovl-smart-screen-margins ovl-smart-screen-margins-lr-large ovl-maxwidth-100ch">
        <h2 class="sap-icon--settings sap-icon--xl">
          ${T("GENUserSettingsTitle")} ${this.state.ovl.user.firstName}
          ${this.state.ovl.user.lastName} (${this.state.ovl.user.userId})
        </h2>

        <comp-sysusersettingspasswordform> </comp-sysusersettingspasswordform>
        ${offeringSettings}
        <comp-sysuseradministrationsettings></comp-sysuseradministrationsettings>
      </div>
    `
  }
}
